import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Filter = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.4978 8.87507H38.5157L24.9818 25.8071L11.4978 8.87507ZM4.06574 7.82653C9.52254 14.7727 19.6015 27.6726 19.6015 27.6726V43.7976C19.6006 44.1516 19.6698 44.5023 19.8052 44.8298C19.9406 45.1571 20.1395 45.4548 20.3905 45.7058C20.6416 45.9567 20.9399 46.156 21.2683 46.2923C21.5968 46.4285 21.949 46.4991 22.3049 46.5H27.7085C28.4244 46.4983 29.1105 46.2148 29.6171 45.7116C30.1236 45.2084 30.4094 44.5263 30.412 43.8142V27.6892C30.412 27.6892 40.461 14.7892 45.9211 7.84307C46.2356 7.44618 46.431 6.969 46.4848 6.46649C46.5385 5.96398 46.4485 5.45657 46.2251 5.00273C46.0016 4.54888 45.6539 4.16704 45.2218 3.90119C44.7898 3.63534 44.291 3.4963 43.783 3.50007H6.20058C5.69573 3.49937 5.20082 3.63964 4.77217 3.90493C4.34352 4.17021 3.99833 4.54985 3.77589 5.00065C3.55345 5.45145 3.46269 5.9553 3.51393 6.45488C3.56517 6.95446 3.75636 7.4297 4.06574 7.82653Z"
        fill={color}
      />
    </svg>
  )
}
